var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-sm-1 mt-0"},[_vm._m(0),_c('MarketTypeForm',{attrs:{"createMode":""}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header"},[_c('h1',{staticClass:"page-title fw-bold"},[_vm._v("Type de marché")])])
}]

export { render, staticRenderFns }